import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import VueCookies from "vue-cookies";
import VueClipboard from 'vue-clipboard2'
import store from "./store";
import VueMasonry from 'vue-masonry-css'


// router setup
import router from "./routes/router";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueCookies);
Vue.use(VueMasonry);

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

// Vue.prototype.$apiUrl = process.env.NODE_ENV === "production" 
// ? "https://teach.huestimates.app/api/controller" 
// : "http://localhost:7710/controller" 

Vue.prototype.$apiUrl = "https://teach.huestimates.app/api/controller";


Vue.mixin({
  
  methods: {
    notifyVue(type = "default", text) {
      if (!text) {
        if (type === "success") {
          text = "Changes have been saved!";
        } else if (type === "danger") {
          text = "Action failed!";
        }
      }
      this.$notify({
        timeout: 5000,
        message: text,
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: type,
        icon: "ni bell"
      });
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router
});
